import React from 'react'

import { useFindMenu, useLocale, useTrans } from 'hooks'
import { getIcon } from '@utils/icons'
import { Logo } from '@components/icons'
import { WContainer, WImage, WLink } from 'components/atoms'
import styles from './Footer.module.sass'
import { trackingGAevent, uniformData } from '@utils/gtm'
import LogoEmilamerica from '@components/icons/LogoEmilamerica'

interface Props {
  className?: string
  langs?: any[]
}

const Footer = (props: Props) => {
  const { className = '' } = props

  const t = useTrans()
  const { isAmerica } = useLocale()

  const footerMenu = useFindMenu('footer')
  const socialMenu = useFindMenu('social')
  const partecipazioninMenu = useFindMenu('partecipazioni')

  return (
    <footer className={`${styles.root} ${className}`}>
      <WContainer>
        <div className={styles.layout}>
          <div className={styles.info}>
            <WLink href={'/'} className={styles.logo} ariaLabel="Logo">
              {isAmerica ? <LogoEmilamerica idVariant="footer" /> : <Logo idVariant="footer" />}
            </WLink>
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{
                __html: t(
                  `<p>© Emilceramica S.r.l. a socio unico</p>
                <p>
                  Società soggetta a direzione e coordinamento di Mohawk Industries Inc Fiorano Modenese (MO), 
                  Via Ghiarola Nuova n. 29 Capitale Sociale: €10.000.000 int. vers.
                </p>
                <p>
                  Iscritta al Registro Imprese di Modena<br />
                  Codice Fiscale e P.IVA n. 03716700368
                </p>`
                ),
              }}
            ></div>
          </div>
          {!!footerMenu?.children?.length && (
            <nav className={styles.menu}>
              {footerMenu.children.map((x) => (
                <div key={x.pk} className={styles.menuCol}>
                  {x.children?.length && (
                    <ul className={styles.submenu}>
                      {x.children.map((y) => (
                        <li
                          key={y.pk}
                          className={styles.submenuItem}
                          {...(y.key === 'gestione_preferenze'
                            ? {
                                onClick: (e) => {
                                  e.preventDefault()
                                  Cookiebot.renew()
                                },
                              }
                            : {})}
                        >
                          <WLink href={y.url} newPage={y.blank || undefined}>
                            {y.name}
                          </WLink>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </nav>
          )}
          <div className={styles.utils}>
            {!!socialMenu?.children?.length && (
              <ul className={styles.social}>
                {socialMenu.children?.map((y) => (
                  <li key={y.pk}>
                    <WLink
                      href={y.url}
                      newPage={y.blank}
                      className={styles.socialItem}
                      ariaLabel={y.name}
                    >
                      {getIcon(y.style, y.pk)}
                    </WLink>
                  </li>
                ))}
              </ul>
            )}
            {!!partecipazioninMenu?.children?.length && (
              <div className={styles.partecipazioni}>
                {!!partecipazioninMenu.name && (
                  <p className={styles.partecipazioniTitle}>{partecipazioninMenu.name}</p>
                )}
                <ul className={styles.partecipazioniMenu}>
                  {partecipazioninMenu.children.map((x) => (
                    <li key={x.pk}>
                      <WLink href={x.url} newPage={x.blank} className={styles.partecipazioniItem}>
                        <WImage
                          src={x.image}
                          maxWidth={98}
                          maxHeight={80}
                          alt={x.name}
                          title={x.name}
                        />
                      </WLink>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </WContainer>
    </footer>
  )
}

export default React.memo(Footer)
